import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, HostBinding, Input, OnChanges, Renderer2, ViewChild, inject } from '@angular/core';
import { IconService } from './icon.service';
import { completeIconSet } from './icons';
import { completeFlagSet } from './flags';
import { IconName } from '../_shared/models/icon.model';

@Component({
    standalone: true,
    selector: 'sirius-icon',
    template: `<div #div></div>`,
    styleUrls: ['./icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconComponent implements AfterViewInit, OnChanges {
    private _renderer = inject(Renderer2);
    private _iconService = inject(IconService);

    @Input() name: IconName = 'house';

    @ViewChild('div') private _svgContainer!: ElementRef<HTMLElement>;

    constructor() {
        const _iconService = this._iconService;

        _iconService.addIcons([completeIconSet, completeFlagSet]);
    }

    @HostBinding('class.sir-pictogram')
    get isPictogram(): boolean {
        return this._iconService.isPictogram(this.name);
    }

    @HostBinding('class.sir-flag')
    get isFlag(): boolean {
        return this._iconService.isFlag(this.name);
    }

    ngAfterViewInit(): void {
        this._renderer.addClass(this._svgContainer.nativeElement, 'sir-container');
        this._render();
    }

    ngOnChanges(): void {
        this._render();
    }

    private _render(): void {
        if (!this._svgContainer) {
            return;
        }

        this._svgContainer.nativeElement.innerHTML = this._iconService.getIcon(this.name);
    }
}
